import { GetTermsGlobalAccountApiProps } from 'services/terms-global-account/types'
import { getTermsGlobalAccount } from 'services/terms-global-account'

import { useQuery } from '@tanstack/react-query'

export const useGetTermsGlobalAccount = () =>
  useQuery<GetTermsGlobalAccountApiProps[]>(['terms-global-account'], () => getTermsGlobalAccount())
